import Cookies from 'universal-cookie';

import { RECENTLY_VIEWED_MAX_SKUS } from '@/constants/constants';
import { COOKIE_RECENTLY_VIEWED } from '@/constants/cookie.constants';

import { getCookieExpiryRecentlyViewed } from './getCookieExpiry';

const cookies = new Cookies();

export const addSkuToRecentlyViewedArray = (sku: string, recentlyViewed: string[]): string[] => {
  // Add the SKU at the beginning of the array
  const resultRaw = [sku, ...recentlyViewed];
  // Remove duplicates from the array and cap the results
  const result = [...new Set(resultRaw)].slice(0, RECENTLY_VIEWED_MAX_SKUS);
  return result;
};

export const getRecentlyViewedCookie = (): string[] => {
  const cookieValue = cookies.get(COOKIE_RECENTLY_VIEWED);
  if (Array.isArray(cookieValue)) {
    return cookieValue;
  }
  return [];
};

const setRecentlyViewedCookie = (skus: string[]) => {
  cookies.set(COOKIE_RECENTLY_VIEWED, JSON.stringify(skus), {
    path: '/',
    secure: process.env.NODE_ENV === 'production',
    expires: getCookieExpiryRecentlyViewed(),
    sameSite: 'lax',
  });
};

export const addSkuToRecentlyViewed = (sku: string) => {
  const skus = addSkuToRecentlyViewedArray(sku, getRecentlyViewedCookie());
  setRecentlyViewedCookie(skus);
};
